import { api } from "@/infrastructure/api";
import { all, call, put, takeLatest } from "redux-saga/effects";
import * as A from "./actions";
import * as T from "./types";
import { AxiosResponse } from "axios";

export function* fetchAnomalies() {
  try {
    const { data }: AxiosResponse<{ anomalyDate: string; data: T.AnomalData }> = yield call(
      api.get,
      `/anomalies/pv-anomalies/SGX`
    );

    yield put(A.fetchAnomalDataAsync.success(data));
  } catch (e) {
    yield put(A.fetchAnomalDataAsync.failure());
  }
}

export function* fetchScreenerMeta({ payload }: ReturnType<typeof A.fetchScreenerMetaAsync.request>) {
  try {
    const { data }: AxiosResponse<T.ScreenerMeta> = yield call(api.get, `/anomalies/screener/${payload}`);

    yield put(A.fetchScreenerMetaAsync.success(data));
  } catch (e) {
    yield put(A.fetchScreenerMetaAsync.failure());
  }
}

export function* fetchIndustryMeta({ payload }: ReturnType<typeof A.fetchIndustryMetaAsync.request>) {
  try {
    const { data }: AxiosResponse<Partial<T.ScreenerMeta>> = yield call(
      api.get,
      `/anomalies/screener/industry-meta/${payload}`
    );

    yield put(A.fetchIndustryMetaAsync.success(data));
  } catch (e) {
    yield put(A.fetchIndustryMetaAsync.failure());
  }
}

export function* fetchScreenerFilter({ payload }: ReturnType<typeof A.fetchScreenerFilterAsync.request>) {
  try {
    const { data }: AxiosResponse<T.ScreenerResult[]> = yield call(
      api.post,
      `/anomalies/screener/${payload.country}`,
      payload
    );

    yield put(A.fetchScreenerFilterAsync.success(data));
  } catch (e) {
    yield put(A.fetchScreenerFilterAsync.failure());
  }
}

export function* fetchNavbarData({ payload }: ReturnType<typeof A.fetchNavBarDataAsync.request>) {
  try {
    const { data }: AxiosResponse<T.NavBarData[]> = yield call(
      api.post,
      `/anomalies/screener/navbar/${payload.type}`,
      payload.tickers
    );

    yield put(A.fetchNavBarDataAsync.success({type: payload.type, data}));
  } catch (e) {
    yield put(A.fetchNavBarDataAsync.failure());
  }
}

export default function*() {
  yield all([
    takeLatest(A.fetchAnomalDataAsync.request, fetchAnomalies),
    takeLatest(A.fetchScreenerMetaAsync.request, fetchScreenerMeta),
    takeLatest(A.fetchIndustryMetaAsync.request, fetchIndustryMeta),
    takeLatest(A.fetchScreenerFilterAsync.request, fetchScreenerFilter),
    takeLatest(A.fetchNavBarDataAsync.request, fetchNavbarData)
  ]);
}
